module.exports = __webpack_public_path__ + "1c3a5554a0d8d1afaaf56164415da91c.svg";